export const types = {
    //************ Auth ************
    authCheckingFinish: '[Auth] Finish checking login state',
    authLogin: '[Auth] Login',
    authLogout: '[Auth] Logout',
    authStartTokenRenew: '[Auth] Start token renew',

    //************ ui ************
    uiPagination: '[UI] Handle Search',
    uiShowSidebar: '[UI] Handle Show Sidebar',
    uiSetActiveCrud: '[UI] Set active crud',
    uiSetImgEditCuento: '[UI] Set image edit cuento',
    uiAlertError: '[UI] Handle Alert Error',
    uiSetLoading: '[UI] Set loading',
    
    //************ curd ************
    crudSetActive: '[CRUD] Set active',

    //cuentos
    crudCreateCuento: '[CRUD] Create cuento',
    crudScrollingCuentos: '[CRUD] Scrolling Cuentos',
    crudUpdateCuentos: '[CRUD] Update all cuento',
    crudResetCuentos: '[CRUD] Reset all cuentos',
    crudDeleteCuentos: '[CRUD] Delete cuento',

    //dibujos
    crudReadDibujos: '[CRUD] Read all dibujos',
    crudScrollingDibujos: '[CRUD] Scrolling dibujos',
    crudCreateDibujo: '[CRUD] Create dibujo',
    crudDeleteDibujos: '[CRUD] Delete dibujo',

    
}